<template lang="pug">
button.main-button(:class="buttonClass", @click="buttonClickEvent")
  slot {{ label }}
</template>
<script>
export default {
  name: "MainButton",
  props: {
    label: {
      type: String,
      default: "текст кнопки",
      required: true,
    },
    isTransparent: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isBordered: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    buttonClass() {
      return [
        this.isTransparent ? "main-button--transparent" : "main-button--red",
        this.isDisabled ? "main-button--disabled" : "",
        this.isBordered ? "" : "main-button--no-border",
      ];
    },
  },

  methods: {
    buttonClickEvent() {
      if (!this.isDisabled) this.$emit("buttonClickEvent");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/main-button.scss";
</style>
